export const fr = {
  // Navigation
  nav: {
    home: "Accueil",
    ourServices: "Nos Services",
    aboutUs: "À Propos",
    ourTeam: "Notre Équipe",
    contactUs: "Contactez-nous"
  },

  // Hero Section
  hero: {
    title: "Développez-vous mondialement avec confiance",
    subtitle: "Nous vous soutenons dans la création de votre entreprise aux Émirats arabes unis, en Arabie saoudite et en Russie.",
    consultationTitle: "Réservez une Consultation Gratuite Maintenant",
    startNow: "Commencer",
    modalTitle: "Réservez une Consultation Gratuite",
    countrySelect: "Sélectionnez Votre Pays",
    countryPlaceholder: "Choisissez un pays",
    personalInfo: "Informations Personnelles",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    emailAddress: "Adresse E-mail",
    nationality: "Nationalité",
    phoneNumber: "Numéro de Téléphone",
    servicesLabel: "Les Services que vous souhaitez",
    serviceSelect: "Sélectionnez un service",
    service1: "Ouvrir des Comptes Bancaires",
    service2: "Services de Visa et d'Immigration",
    service3: "Réservation d'Hôtels",
    service4: "Billets d'Avion",
    service5: "Développement de Sites Web",
    service6: "Développement d'Applications Mobiles",
    submit: "Soumettre"
  },

  // About Us Section
  aboutUs: {
    title: "À Propos de Nous",
    paragraph1: "Itqan Business Services a été fondée aux Émirats arabes unis pour aider les entrepreneurs et les entreprises à établir leurs sociétés facilement et rapidement. Nous fournissons une gamme complète de services incluant la formation de sociétés continentales et de zones franches, les services PRO et gouvernementaux, les conseils fiscaux et TVA, les états financiers et l'attestation de documents.",
    paragraph2: "Au fil des années, nous sommes devenus un partenaire de confiance pour les entrepreneurs et les PME, offrant des solutions juridiques, financières et réglementaires transparentes qui soutiennent la croissance aux Émirats arabes unis et au-delà. Notre mission est claire : rendre la création et l'exploitation d'entreprises simples, rapides et fiables — afin que vous puissiez vous concentrer sur la réussite."
  },

  // Services Section
  services: {
    title: "Nos Services",
    subtitle: "Nous fournissons des solutions commerciales complètes",
    startingFrom: "À partir de",
    mainlandCompany: {
      name: "Formation de Société Continentale",
      desc: "Créez votre société continentale facilement. Nous gérons toutes les étapes légales pour que vous puissiez vous concentrer sur la croissance de votre entreprise.",
      price: "10 000 AED"
    },
    freeZoneCompany: {
      name: "Formation de Société en Zone Franche",
      desc: "Lancez votre entreprise en zone franche rapidement et à moindre coût. Profitez d'une propriété flexible et d'une configuration simplifiée.",
      price: "6 000 AED"
    },
    proServices: {
      name: "Services PRO et Gouvernementaux",
      desc: "Du renouvellement de licences aux visas dorés, nous gérons toutes vos transactions gouvernementales en douceur."
    },
    taxConsultancy: {
      name: "Conseil Fiscal et TVA",
      desc: "Restez conforme avec les conseils fiscaux et TVA d'experts. Nous vous aidons à minimiser les risques et maximiser l'efficacité."
    },
    financialStatements: {
      name: "États Financiers",
      desc: "Rapports financiers précis qui maintiennent votre entreprise sur la bonne voie. Nous assurons la transparence et la conformité."
    },
    documentAttestation: {
      name: "Attestation de Documents",
      desc: "Services d'attestation de documents rapides et fiables pour tous vos besoins commerciaux."
    },
    bankAccounts: {
      name: "Ouvrir des Comptes Bancaires",
      desc: "Assistance professionnelle pour l'ouverture de comptes bancaires pour les particuliers et les entreprises aux Émirats arabes unis et à l'international."
    },
    visaServices: {
      name: "Services de Visa et d'Immigration",
      desc: "Services complets de visa et d'immigration incluant les visas touristiques, les visas d'affaires et les permis de résidence."
    },
    hotelBooking: {
      name: "Réservation d'Hôtels",
      desc: "Services de réservation d'hôtels pratiques pour les voyages d'affaires et les voyages de loisirs avec des tarifs compétitifs."
    },
    flightTickets: {
      name: "Billets d'Avion",
      desc: "Services de réservation de vols fiables avec accès aux meilleures offres et itinéraires mondiaux."
    },
    websiteDevelopment: {
      name: "Développement de Sites Web",
      desc: "Services de développement de sites web personnalisés pour établir votre présence en ligne et développer votre entreprise.",
      price: "1 500 AED"
    },
    mobileAppDevelopment: {
      name: "Développement d'Applications Mobiles",
      desc: "Développement professionnel d'applications mobiles pour les plateformes iOS et Android.",
      price: "3 500 AED"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "Notre Équipe",
    subtitle: "Rencontrez nos professionnels experts",
    members: [
      {
        name: "Ing/Hana",
        role: "Chef d'équipe de création d'entreprise"
      },
      {
        name: "Ing/Ali",
        role: "Chef d'équipe de création d'entreprise"
      },
      {
        name: "Ing/Abdalla",
        role: "Chef d'équipe de création d'entreprise"
      },
      {
        name: "Ing/Sara",
        role: "Chef d'équipe de création d'entreprise"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "Ce que Disent Nos Clients",
    subtitle: "Témoignages de clients satisfaits",
    testimonials: [
      {
        name: "Jean Dupont",
        role: "PDG, TechStart Inc.",
        text: "Itqan a rendu la création de ma société à Dubaï si simple et rapide. Leur équipe a tout géré professionnellement, et j'ai pu commencer mon entreprise sans stress. La configuration de la zone franche a été terminée en seulement 3 jours !"
      },
      {
        name: "Samir Martin",
        role: "Responsable Marketing, Solutions Globales",
        text: "Grâce à leurs conseils fiscaux, j'ai maintenant pleine confiance que mon entreprise est conforme et financièrement sécurisée. Leur expertise m'a fait économiser des milliers en pénalités potentielles."
      },
      {
        name: "Michel Brun",
        role: "Propriétaire d'entreprise, Chaîne de Magasins",
        text: "L'équipe des services PRO chez Itqan est exceptionnelle. Ils ont géré toutes mes transactions gouvernementales en douceur, du renouvellement de licences aux demandes de visa. Hautement recommandé !"
      },
      {
        name: "Mike Roberson",
        role: "Freelance, Agence Digitale",
        text: "En tant que freelance, j'avais besoin d'aide pour l'attestation de documents et l'ouverture de compte bancaire. Itqan a tout rendu si facile et abordable. Maintenant je peux me concentrer sur mes clients pendant qu'ils s'occupent de la paperasserie."
      },
      {
        name: "David Lee",
        role: "Entrepreneur, E-commerce",
        text: "Leurs services d'états financiers sont excellents. Les rapports sont précis, détaillés et m'ont aidé à obtenir un financement pour l'expansion de mon entreprise. Service professionnel tout au long !"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "Nos Partenaires",
    subtitle: "Approuvé par les organisations de premier plan"
  },

  // Contact Us Section
  contactUs: {
    title: "Contactez-nous",
    subtitle: "Entrez en contact avec nous",
    getInTouch: "Entrez en Contact",
    contactInfo: "Informations de Contact",
    sendMessage: "Envoyer un Message",
    name: "Nom",
    email: "E-mail",
    subject: "Sujet",
    message: "Message",
    fullName: "Nom Complet",
    fullNamePlaceholder: "Entrez votre nom",
    emailAddress: "Adresse E-mail",
    emailPlaceholder: "Entrez votre e-mail",
    phoneNumber: "Numéro de Téléphone",
    phonePlaceholder: "Numéro de Téléphone",
    activity: "Activité",
    activityPlaceholder: "Entrez votre activité",
    submit: "Soumettre"
  },

  // Footer
  footer: {
    allRightsReserved: "Tous Droits Réservés",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions de Service",
    description: "Services Commerciaux Itqan – Rendre la création d'entreprise facile et rapide.",
    location: "Localisation: Dubaï, Émirats Arabes Unis",
    phone: "📞 Téléphone: +971 XXX XXX XXX",
    email: "✉️ E-mail: info@itqan.com",
    copyright: "© 2025 Services Commerciaux Itqan. Tous Droits Réservés.",
    companyProfile: "Profil d'Entreprise"
  },

  // Ad Section
  ad: {
    title: "Développez-vous mondialement avec confiance",
    startNow: "Commencer"
  },

  // Statistics Section
  statistics: {
    title: "Nos Réalisations",
    subtitle: "Des chiffres qui parlent de notre succès",
    clients: "Clients Satisfaits",
    experience: "Années d'Expérience",
    partners: "Partenaires de Confiance"
  }
}; 